import {Modal} from "@mantine/core";

export const DataListModal = ({opened, onClose, children}) => {
    return (
        <Modal
            opened={opened}
            onClose={onClose}
            withCloseButton={false}
            size="70%"
            overlayProps={{
                backgroundOpacity: 0.25,
            }}
            radius={15}
            classNames={{
                body: "scroll-y-auto h-[60%]",
                content: 'px-8 pt-4',
            }}
            styles={{
                content: {overflowY: 'auto'}
            }}
            centered
        >
            {children}
        </Modal>
    )
}